import PropTypes from "prop-types";
import React, { Component } from "react";
import theme, { themeOptions } from "styles/theme";
import Globalize from "globalize";
import Button from "components/form/flat-button";
import Entry from "models/catalog/entry";
import fetch from "lib/fetch";
import { format } from "lib/globalize-util";
import { Link } from "react-router";
import { connect } from "react-redux";
import { activeListSet } from "actions/active-list";
import { FormatMessage } from "react-globalize";
import shallowequal from "shallowequal";
import { invalidateCacheKey } from "actions/entries";
import { Message as SuccessMessage } from "./message";
import { getCatalogSummaryMessage } from "helpers/catalog-entries";
import _ from "lodash";
import { gtm } from "helpers/gtm";

const styles = {
    select: {
        padding: "8px",
        borderBottom: "1px solid " + themeOptions.palette.lightGrey,
        cursor: "pointer",
    },
    base: {
        position: "relative",
        height: "100px",
        padding: "8px 120px 8px 12px",
        cursor: "pointer",
        borderBottom: "1px solid " + themeOptions.palette.lightGrey,
        overflow: "hidden",
    },
    button: {
        position: "absolute",
        top: "50%",
        right: "0px",
        textAlign: "right",
        transform: "translateY(-50%)",
    },
    title: {
        fontSize: "16px",
        fontWeight: 800,
        margin: "8px 0px 12px",
        padding: "0px",
        color: themeOptions.palette.darkerGrey,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    titleSelect: {
        display: "inline-block",
        fontSize: "12px",
        fontWeight: 400,
        margin: "0px",
        lineHeight: "14px",
        height: "14px",
        padding: "0px",
        color: themeOptions.palette.darkerGrey,
        wordWrap: "break-word",
    },
    details: {
        display: "flex",
    },
    dl: {
        overflow: "auto",
        margin: "0 24px 0 0",
    },
    dt: {
        display: "block",
        padding: "0 0 2px",
        width: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: themeOptions.palette.darkGrey,
        fontWeight: "normal",
        fontSize: "12px",
    },
    dd: {
        display: "block",
        padding: `0 0 ${theme.spacing.desktopGutter}px`,
        fontSize: "14px",
        color: themeOptions.palette.darkerGrey,
        fontWeight: "normal",
    },
};

class Item extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    static propTypes = {
        catalog: PropTypes.object.isRequired,
        item: PropTypes.object,
        bulkItems: PropTypes.object,
        entities: PropTypes.object,
        type: PropTypes.oneOf(["item", "catalog"]),
        filters: PropTypes.object,
        onRequestClose: PropTypes.func,
        searchTerm: PropTypes.string,
        currentCatalog: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        onChangeCatalog: PropTypes.func,
        notes: PropTypes.string,
        scope: PropTypes.object.isRequired,
        sortBy: PropTypes.string,
        positionToAdd: PropTypes.string,
        sortOrder: PropTypes.string,
        onSnackbarAdd: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            added: false,
        };

        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !shallowequal(this.props, nextProps) || !shallowequal(this.state, nextState);
    }

    handleSuccess = (action, entry) => {
        const { me } = this.context;
        const {
            bulkItems,
            item,
            catalog,
            entries,
            entities,
            onChangeCatalog,
            onInvalidateCacheKey,
            onSnackbarAdd,
            onSetActiveList,
            scope,
        } = this.props;
        const { id, title } = catalog;
        const type = catalog.type === "linesheet" ? "linesheet" : "list";
        const { items, value } = gtm.formatItemsWithBulk({
            items: { single: item, bulk: bulkItems },
            props: { entities, scope },
            list: { affiliation: type, item_list_id: id, item_list_name: title },
        });
        gtm.emit(
            gtm.events.addToWishlist({
                currency: me._activeCurrency,
                items,
                value,
                send_to: gtm.groups.Brand,
            }),
        );
        me.trackAction("Add item to catalog", {
            createNew: false,
            bulk: action === "bulk",
            selectAll: action === "bulk" ? bulkItems.allSelected : false,
            type,
        });

        onSetActiveList(catalog);

        if (catalog && entries && entries[id] && entries[id].cacheKey) {
            onInvalidateCacheKey(id);
        }

        if (onSnackbarAdd) {
            onSnackbarAdd({
                message: (
                    <SuccessMessage action={action} catalog={catalog} entry={entry} onChangeCatalog={onChangeCatalog} />
                ),
            });
        }
    };

    handleTouchTap(e) {
        const {
            item,
            catalog,
            bulkItems,
            filters,
            searchTerm,
            onRequestClose,
            currentCatalog,
            onSetActiveList,
            type,
            entities,
            notes,
            sortBy,
            sortOrder,
            onSnackbarAdd,
            onSelect,
            scope,
            positionToAdd,
        } = this.props;

        if (onSelect) {
            onSelect(catalog);
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        this.setState({ added: true });

        if (item) {
            const entry = new Entry();
            entry.save(
                {
                    item_id: item._id,
                    type: "item",
                    catalogId: catalog.id,
                    notes: notes,
                    company: scope.viewAs && scope.viewAs._id,
                },
                {
                    success: () => {
                        this.handleSuccess("item", entry);
                    },
                    error: (model, { statusCode, body }) => {
                        let message = format("Error adding product");

                        switch (statusCode) {
                            case 403:
                                if (_.size(body?.rejectedEntriesGroupedByCause?.warehouse)) {
                                    message = format(
                                        "|n| product(s) could not be added because they are not available in the selected warehouse.",
                                        {
                                            n: _.size(body.rejectedEntriesGroupedByCause.warehouse),
                                        },
                                    );
                                }
                                break;
                            case 409:
                                message = (
                                    <FormatMessage
                                        path="Product already added to catalog"
                                        variables={{ catalog: catalog.title }}
                                        elements={{
                                            link: <Link to={catalog._link} />,
                                        }}
                                    />
                                );
                                break;
                            default:
                                message = format("Error adding product");
                                break;
                        }

                        onSnackbarAdd({ message });
                    },
                },
            );
        } else if (bulkItems && bulkItems.size) {
            // assume bulk action
            let data;
            if (bulkItems.allSelected) {
                data = filters ? filters.toJS() : {};
                data.__sort = sortBy;
                data.__sort_order = sortOrder;
                if (searchTerm) {
                    data.__search = searchTerm;
                }

                if (currentCatalog) {
                    data.__catalog_id = currentCatalog.id;
                }

                // Filter disabled products
                data.__archived = false;
                const active = data.__active || "active";
                delete data.__active;
                switch (active) {
                    case "all":
                        data.__view_disabled = true;
                        break;
                    case "inactive":
                        data.__view_disabled = true;
                        data.__active = false;
                        break;
                    case "active":
                    default:
                        data.__view_disabled = false;
                }
            } else {
                data = {
                    __sort: sortBy,
                    __sort_order: sortOrder,
                    __catalog_id: currentCatalog ? currentCatalog.id : undefined,
                };
            }
            if (scope.viewAs) {
                data.__company = [scope.viewAs._id];
            }

            if (positionToAdd) {
                data.__position = positionToAdd;
            }

            Object.assign(
                data,
                bulkItems.toFilters((id) => (type === "item" ? id : entities.entries[id].item_id)),
            );

            const useWarehouseValidation = scope?.brand?.hasPreference("set_warehouse_for_linesheets");
            const route = useWarehouseValidation
                ? `/api/v3.1/catalog/${catalog.id}/entries/bulk/summarized`
                : `/api/v3.1/catalog/${catalog.id}/entries/bulk`;

            fetch(route, { method: "POST", body: JSON.stringify(data) })
                .then((response) => {
                    if (response.status > 300) {
                        return response.json().then((data) => {
                            throw new Error(data.message || Globalize.formatMessage("Bad response from server"));
                        });
                    }
                    this.handleSuccess("bulk");
                    return response.json().then((data) => {
                        if (useWarehouseValidation) {
                            onSnackbarAdd?.({ message: getCatalogSummaryMessage(catalog, data) });
                            return data.createdEntries;
                        }
                        return data;
                    });
                })
                .catch((e) => {
                    if (onSnackbarAdd) {
                        onSnackbarAdd({ message: e.message });
                    }
                });
        } else {
            // assumes set active list
            onSetActiveList(catalog);
        }
        if (onRequestClose) {
            onRequestClose();
        } else {
            [].forEach.call(document.querySelectorAll(".button-menu"), (el) => {
                el.parentNode.click();
            });
        }
    }

    render() {
        const { catalog, onRequestClose, activeList, item } = this.props;
        const { added } = this.state;

        let active, buttonLabel;
        if (activeList && activeList.id === catalog.id) {
            active = ` (${Globalize.formatMessage("active")})`;
        }

        if (item) {
            buttonLabel = added ? Globalize.formatMessage("Added") : Globalize.formatMessage("Add");
        } else {
            buttonLabel = Globalize.formatMessage("Select");
        }

        if (onRequestClose) {
            return (
                <article data-test={`catalog-${catalog.id}`} style={styles.base} onClick={this.handleTouchTap}>
                    <div>
                        <h3 style={styles.title}>
                            {catalog.title}
                            {active}
                        </h3>
                        <div style={styles.details}>
                            <dl style={styles.dl}>
                                <dt style={styles.dt}>{Globalize.formatMessage("Last Modified")}:</dt>
                                <dd style={styles.dd}>{catalog.modified_on.local().format("MMM D, YYYY @ h:mm A")}</dd>
                            </dl>

                            <dl style={styles.dl}>
                                <dt style={styles.dt}>{Globalize.formatMessage("Created On")}:</dt>
                                <dd style={styles.dd}>{catalog.created_on.local().format("MMM D, YYYY @ h:mm A")}</dd>
                            </dl>
                        </div>
                    </div>

                    <Button disabled={added} style={styles.button} label={buttonLabel} />
                </article>
            );
        }
        return (
            <article data-test={`catalog-${catalog.id}`} onClick={this.handleTouchTap} style={styles.select}>
                <h3 style={styles.titleSelect}>{catalog.getTruncatedName(active)}</h3>
            </article>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeList: state.activeList.current,
        entries: state.entries.collections,
        scope: state.scope,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        onSetActiveList: (catalog) => {
            dispatch(activeListSet(catalog));
        },
        onInvalidateCacheKey: (catalogId) => dispatch(invalidateCacheKey(catalogId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
